import React, { useEffect, useContext, useState } from "react";
import { Context } from "../../utils/context";
import { useParams } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPinterest,
  FaCartPlus,
} from "react-icons/fa";
import "./SingleProduct.scss";
import { urlFor, client } from "../../lib/client";

const SingleProduct = () => {
  const [quantity, setQuantity] = useState(1);

  const { handleAddToCart } = useContext(Context);

  const { id } = useParams();
  const [product, setProduct] = useState(null);
  console.log(product);

  useEffect(() => {
    const query = '*[_type == "product"]';
    client.fetch(query).then((data) => {
      setProduct(data.find((item) => item._id === id));
    });
  }, [id]);

  const decrement = () => {
    setQuantity((prevState) => {
      if (prevState === 1) return 1;
      return prevState - 1;
    });
  };
  const increment = () => {
    setQuantity((prevState) => prevState + 1);
  };

  if (!product) return;
  return (
    <div className="single-product-main-content">
      <div className="layout">
        <div className="single-product-page">
          <div className="left">
          <img
              src={
                urlFor(product?.image[0])
              } alt={product?.brand}
            />
          </div>
          <div className="right">
            <span className="name">{product?.name}</span>
            <span className="price">£{product?.price}</span>
            <span className="desc"><p>{product?.description}</p></span>

            <div className="cart-buttons">
              <div className="quantity-buttons">
                <span onClick={decrement}>-</span>
                <span>{quantity}</span>
                <span onClick={increment}>+</span>
              </div>
              <button
                className="add-to-cart-button"
                onClick={() => {
                  handleAddToCart(product, quantity);
                  setQuantity(1);
                }}
              >
                <FaCartPlus size={20} />
                ADD TO CART
              </button>
            </div>

            <span className="divider" />
            <div className="info-item">
              <span className="text-bold">
                Category:{" "}
                {/* <span>{product.categories.data[0].attributes.title}</span> */}
              </span>
              <span className="text-bold">
                Share:
                <span className="social-icons">
                  <FaFacebookF size={16} />
                  <FaTwitter size={16} />
                  <FaInstagram size={16} />
                  <FaLinkedinIn size={16} />
                  <FaPinterest size={16} />
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleProduct;
